module.exports = __webpack_public_path__ + "static/media/green-tick.207c48d6.svg";